import React, { FunctionComponent } from 'react';
import { UniversePageSectionsCollection } from '../../generated/contentful-generated-types';
import { UNIVERSE_SECTION_TYPES } from '../../common/constants';
import { HighlightImage } from './HighlightImage';
import { HighlightContentBoxes } from './HighlightContentBoxes';
import { HighlightNoImage } from './HighlightNoImage';
import { ProductOrCategoryPage } from './ProductOrCategoryPage';
import { FAQ } from './FAQ';

interface Props {
  sections: UniversePageSectionsCollection;
}
const sectionDisplayComponents = {
  [UNIVERSE_SECTION_TYPES.HIGHLIGHT_IMAGE]: HighlightImage,
  [UNIVERSE_SECTION_TYPES.HIGHLIGHT_NO_IMAGE]: HighlightNoImage,
  [UNIVERSE_SECTION_TYPES.HIGHLIGHT_CONTENTBOXES]: HighlightContentBoxes,
  [UNIVERSE_SECTION_TYPES.PRODUCTS_OR_CATEGORYPAGE]: ProductOrCategoryPage,
  [UNIVERSE_SECTION_TYPES.FAQ]: FAQ
};

export const SectionsDispatcher: FunctionComponent<Props> = ({ sections }) => {
  if (!sections?.items || !Array.isArray(sections.items)) {
    // handle error or return null or some default UI
  }

  return (
    <>
      {sections.items.map((section, index) => {
        const SectionComponent = section?.sectionType ? sectionDisplayComponents[section.sectionType] : null;

        return SectionComponent && section ? <SectionComponent key={index} section={section} /> : <div key={index}>Unknown section type</div>;
      })}
    </>
  );
};
